module.exports = __webpack_public_path__ + "static/img/summer_banner.90bbe0f7.jpg";